<template>
    <div v-if="feedbacks" class="grid grid-nogutter justify-content-between">
        <div v-for="(feedback, index) in feedbacks" :key="index" class="col-12 md:col-6 p-2"
            @click="$emit('view-feedback', feedback)" style="cursor: pointer;">
            <div class="surface-section border-round shadow-1 p-4 flex flex-column gap-2 h-full">
                <div class="flex justify-content-between align-items-start">
                    <div class="flex gap-3 align-items-center flex-1">
                        <img :src="feedback.photoURL ? feedback.photoURL : blankProfile"
                            class="h-3rem w-3rem border-circle" />
                        <div class="flex flex-column flex-1">
                            <span class="font-semibold whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                                {{ feedback.studentName }}
                            </span>
                            <span
                                class="text-color-secondary text-sm mt-1 whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                                {{ cleanupLables(feedback.studentGrade) }}
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-column align-items-end flex-none">
                        <div class="flex gap-1">
                            <i v-for="n in 5" :key="n" class="pi pi-star"
                                :class="n <= feedback.rating ? 'text-yellow-500' : 'text-400'"></i>
                        </div>
                        <span class="text-color-secondary text-sm mt-1">{{ feedback.created_at }}</span>
                    </div>
                </div>
                <Divider class="w-full" />
                <div class="Label">Review for - {{ feedback.tutorName }}</div>
                <div class="text-color-secondary text-sm">{{ feedback.review }}</div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="flex align-items-center justify-content-center" style="min-height: calc(100vh - 600px)">
            <div class="text-center">
                <i class="pi pi-inbox" style="font-size: 2rem; color: var(--gray-100)"></i>
                <p class="mt-2 text-color-secondary">No Reviews found</p>
            </div>
        </div>
    </div>
</template>
<script setup>
import Divider from "primevue/divider";
import { defineProps, defineEmits } from "vue";
import blankProfile from '@/assets/blank-profile.png';
import { cleanupLables } from "@/utils/cleanups";
defineProps({
    feedbacks: null
})
defineEmits(["view-feedback"]);
</script>